export default __webpack_public_path__ + "static/media/filter_icon_parking_blue.60ffd183.svg";